/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaVectorQualityDefinition from './AqaVectorQualityDefinition';

/**
 * The AqaVectorQualityDefinitionArchive model module.
 * @module model/AqaVectorQualityDefinitionArchive
 * @version v0
 */
export default class AqaVectorQualityDefinitionArchive {
  /**
   * Constructs a new <code>AqaVectorQualityDefinitionArchive</code>.
   * @alias module:model/AqaVectorQualityDefinitionArchive
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVectorQualityDefinitionArchive</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVectorQualityDefinitionArchive} obj Optional instance to populate.
   * @return {module:model/AqaVectorQualityDefinitionArchive} The populated <code>AqaVectorQualityDefinitionArchive</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVectorQualityDefinitionArchive();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('vqd'))
        obj.vqd = AqaVectorQualityDefinition.constructFromObject(data['vqd']);
      if (data.hasOwnProperty('personId'))
        obj.personId = ApiClient.convertToType(data['personId'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaVectorQualityDefinitionArchive.prototype.id = undefined;

/**
 * @member {module:model/AqaVectorQualityDefinition} vqd
 */
AqaVectorQualityDefinitionArchive.prototype.vqd = undefined;

/**
 * @member {String} personId
 */
AqaVectorQualityDefinitionArchive.prototype.personId = undefined;

